import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'

export type AccountSettingsConfigType = {
  title: string
  button: JSX.Element
}

export type DateLimitValue = {
  title: DateLimitOptions
  dateLabel: string
  dateValue: Timestamp | null
  isRecommended: boolean
}

export type DateLimitRecommendations = {
  initialValue: DateLimitOptions
  recommendations: DateLimitConfigType
}

export type DateLimitConfigType = {
  [key in DateLimitOptions]: DateLimitValue | null
}

export enum AccountSections {
  DATE_LIMIT = 'Date limit',
  IMAGE_TIMESTAMP_VALIDATION = 'Image timestamp validation',
  AUDIT_SCAN_FREQUENCY = 'Control Test Frequency',
  GOOGLE_DRIVE = 'Google Drive',
  ANECDOTES = 'Anecdotes',
  SHAREPOINT = 'SharePoint',
  CONFLUENCE = 'Confluence',
  CONFIGURE_RISK_CATEGORY = 'Manage risk categories',
  CONFIGURE_DEPARTMENTS = 'Manage departments',
  CONFIGURE_CONTROL_STATUSES = 'Manage control statuses',
  CONFIGURE_LABELS = 'Labels',
  JIRA_WORKFLOW = 'Jira Workflow',
  SNOW_WORKFLOW = 'ServiceNow Workflow',
  ACCOUNT_PROMPT_OVERRIDE_SOURCE = 'Account Prompt Override Source',
}

export enum DateLimitOptions {
  ACCOUNT_CREATION = 'Account Creation',
  EARLIEST_OPEN_AUDIT = 'Start of Earliest Open Audit',
  CURRENT_BOUNDARY = 'Current Boundary',
  SIX_MONTHS_AGO = 'Six Months Ago Today',
}

export const CUSTOM_DATE_LIMIT_OPTION = 'Custom' as DateLimitOptions

export const CUSTOM_DATE_LIMIT_VALUE = {
  title: CUSTOM_DATE_LIMIT_OPTION,
  dateLabel: 'Select a date',
  dateValue: null,
  isRecommended: false,
}

export const INITIAL_DATE_LIMIT_CONFIG: DateLimitConfigType = {
  [DateLimitOptions.ACCOUNT_CREATION]: null,
  [DateLimitOptions.EARLIEST_OPEN_AUDIT]: null,
  [DateLimitOptions.CURRENT_BOUNDARY]: null,
  [DateLimitOptions.SIX_MONTHS_AGO]: null,
}

export const DATE_LIMIT_ERROR_MESSAGE =
  'Sorry, there was an error setting the date limit. Please try again.'

export const AUDIT_SCAN_FREQUENCY_ERROR_MESSAGE =
  'Sorry, there was an error updating the control test frequency. Please try again.'

export const VALIDATE_IMAGE_TIMESTAMP_ERROR_MESSAGE =
  'Sorry, there was an error setting the image validation. Please try again.'
export const DATE_LIMIT_UPDATE_MESSAGE = 'updated date limit'

export const DATE_LIMIT_BANNER_MESSAGE =
  'The date limit was updated recently. This affects what you see in the Compliance Roadmap.'

export const DATE_LIMIT_DESCRIPTION =
  'Changing this date will affect which evidence Trustero AI considers'

export const ACCOUNT_SETTINGS_GRID_TEMPLATE = 'auto 1fr repeat(2, auto)'
